import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';
import type { IRoute } from '..';

const DriversPage = lazy(() => import('@cobliteam/drivers/src/pages/DriverPage'));
const DriverVehiclePermissionsPage = lazy(() => import('@cobliteam/drivers/src/pages/DriverVehiclePermissionsPage'));

const routes: IRoute[] = [
  {
    path: Location.DRIVER_MANAGEMENT,
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_VEHICLE_PERMISSIONS,
    component: DriverVehiclePermissionsPage,
    exact: true,
  },
];

export default routes;
